import { AjaxSolr } from "../../core/Core.js";

(function ($) {
    AjaxSolr.SynerisPathWidget = AjaxSolr.AbstractFacetWidget.extend({
        constructor: function (attributes) {
            AjaxSolr.SynerisPathWidget.__super__.constructor.apply(this, arguments);
            AjaxSolr.extend(this, {
                options: undefined
            }, attributes);
        },
        clear: function () {
            return this.changeSelection(function () {
                return this.manager.store.removeByValue('fq', new RegExp('^(\{!tag=[A-Za-z0-9_]+})*-?' + this.field + ':'));
            });
        },
        clearUI: function () {
            let $target = $(this.target);
            $target.addClass("baseWidget")
                .addClass("pathWidget");

            let tree = $target.children(".pathTree");
            if (tree.length) {
                // Already exists, destroy and remove all
                let kendotree = tree.data("kendoTreeView");
                if (kendotree)
                    kendotree.destroy();
                tree.remove();
            }
        },
        beforeRequest: function () {
            if (!AjaxSolr.SynerisPathWidget.SearchFromPath) {
                this.clearUI();
                $(this.target).append($("<img style='display:block;margin:auto' src='assets/images/loading_image.gif' class='synAjaxLoad_animation' />"));
            }
            let val = AjaxSolr.SynerisPathWidget.SearchParam;

            let self = this;
            let allPathFacetts = true;

            if (self.manager.store.values("q") !== '*:*') {
                allPathFacetts = false;
            } else {
                $.each(self.manager.store.values("fq"), function (idx, path) {
                    if (path && path.indexOf(self.field) < 0) {
                        allPathFacetts = false;
                    }
                });
            }
            self.manager.store.removeByValue('facet.field', new RegExp('^(\{!ex=[A-Za-z0-9_]+})*-?' + self.field));
            if (allPathFacetts) {
                self.manager.store.addByValue('facet.field', "{!ex=" + self.field.replace(/[\._]/, "") + "}" + self.field);
            } else {
                self.manager.store.addByValue('facet.field', self.field);
            }
        },
        afterRequest: function () {
            if (!AjaxSolr.SynerisPathWidget.SearchFromPath) {
                let self = this;
                let tgt = $(this.target);
                tgt.parent().css("display", "");
                let tree = $("<div class='pathTree'></div>").appendTo(tgt);
                if (!this.manager.response.facet_counts || this.manager.response.facet_counts.facet_fields[this.field] == undefined) {
                    tgt.html("");
                    return;
                }

                let hasMore = this.manager.response.hasMore || false;

                let pathFacets = this.manager.response.facet_counts.facet_fields[this.field];

                let paths = [];

                for (let key in pathFacets) {
                    if (pathFacets.hasOwnProperty(key)) {
                        paths.push(key);
                    }
                }
                paths.sort();
                let roots = [];
                let parentPath = [];

                // Remove /
                let idx = $.inArray("/", paths);
                if (idx >= 0) paths.splice(idx, 1);

                _.each(paths, function (pathStr) {
                    let prefix = "";
                    let prefixIdx = 0;
                    let trimmedPath = pathStr;
                    for (; prefixIdx < pathStr.length; prefixIdx++) {
                        if (pathStr[prefixIdx] !== '/')
                            break;
                    }
                    if (prefixIdx) {
                        prefix = pathStr.substring(0, prefixIdx);
                        if (self.options.delimiter)
                            prefix = prefix.replace(/\//g, self.options.delimiter);

                        trimmedPath = pathStr.substring(prefixIdx);
                    }

                    let spl = trimmedPath.split("/");
                    let node = {
                        id: pathStr,
                        items: [],
                        path: pathStr,
                        text: spl[spl.length - 1] + ": " + pathFacets[pathStr]
                    };
                    let isRoot = !parentPath.length;

                    if (!isRoot) {
                        let found = false;
                        let idx = parentPath.length - 1;
                        for (; idx >= 0; idx--) {
                            if (pathStr.substring(0, parentPath[idx].path.length) === parentPath[idx].path) {
                                parentPath[idx].items.push(node);
                                found = true;
                                break;
                            }
                        }
                        isRoot = !found;
                        if (!isRoot) {
                            if (parentPath.length > idx + 1)
                                parentPath = parentPath.slice(0, idx + 1);
                            parentPath.push(node);
                        }
                    }
                    if (isRoot) {
                        roots.push(node);
                        parentPath.push(node);
                        node.text = prefix + node.text;
                    }
                });

                let getPath = function (node) {
                    let id = node.path.toString();
                    return id;
                };

                let dataSource = new kendo.data.HierarchicalDataSource({ data: roots });
                dataSource.read();

                if (!dataSource.data().length)
                    tgt.parent().css("display", "none");
                else {
                    tgt.parent().css("display", "");

                    tree.kendoTreeView({
                        dataSource: dataSource,
                        select: function (e) {
                            let val = getPath(tree.data("kendoTreeView").dataItem(e.node));
                            AjaxSolr.SynerisPathWidget.SearchParam = val;

                            self.manager.store.removeByValue('fq', new RegExp('^(\{!tag=[A-Za-z0-9_]+})*-?' + self.field + ':'));
                            self.manager.store.addByValue('fq', "{!tag=" + self.field.replace(/[\._]/, "") + "}" + self.fq(val));

                            self.doRequest();
                        },
                        dataBound: function (e) {
                            if (AjaxSolr.SynerisPathWidget.SearchParam && self.manager.store.find('fq', new RegExp('^(\{!tag=[A-Za-z0-9_]+})*-?' + self.field + ':'))) {
                                let treeView = tree.data("kendoTreeView");
                                let dataNode = treeView.dataItem(e.node);
                                let dataSource = treeView.dataSource;
                                let path = AjaxSolr.SynerisPathWidget.SearchParam;

                                let prefix = "";
                                let prefixIdx = 0;
                                for (; prefixIdx < path.length; prefixIdx++) {
                                    if (path[prefixIdx] !== '/')
                                        break;
                                }
                                if (prefixIdx) {
                                    prefix = path.substring(0, prefixIdx);
                                    path = path.substring(prefixIdx);
                                }

                                let pathArr = path.split("/");

                                if (pathArr.length > 0) {
                                    let actPath = pathArr[0];
                                    for (let i = 0; i < pathArr.length; i++) {
                                        if (i > 0)
                                            actPath += "/" + pathArr[i];
                                        let dataItem = dataSource.get(prefix + actPath);
                                        if (dataItem) {
                                            let $node = treeView.findByUid(dataItem.uid);
                                            if ($node) {
                                                treeView.select($node);
                                                treeView.expand($node);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    });
                }
            } else {
                AjaxSolr.SynerisPathWidget.SearchFromPath = false;
            }
        },
        cleanUp: function () {
            let tgt = $(this.target);
            // Remove AJAX animations from facet widgets
            tgt.children(".synAjaxLoad_animation").remove();
        }

    });

})(jQuery);
